import React, { useEffect, useState, useCallback } from 'react';
import './CuponesData.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTicketAlt, faCalendarAlt, faCheckCircle, faTimesCircle, faSync, faSearch } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import NewCupon from '../NewCupon/NewCupon';
import moneda from '../../moneda';

export default function CuponesData() {
    const [cupones, setCupones] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [loading, setLoading] = useState(true);

    const cargarCupones = useCallback(() => {
        setLoading(true);
        fetch(`${baseURL}/cuponesGet.php`)
            .then(res => res.json())
            .then(data => {
                setCupones(data.cupones || data.codigos || []);
            })
            .catch(error => {
                console.error('Error al cargar cupones:', error);
                // Fallback a codigosGet.php
                fetch(`${baseURL}/codigosGet.php`)
                    .then(r => r.json())
                    .then(d => setCupones(d.codigos || []))
                    .catch(e => console.error(e));
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        cargarCupones();
    }, [cargarCupones]);

    const eliminarCupon = (idCodigo, codigo) => {
        Swal.fire({
            title: '¿Eliminar cupón?',
            text: `Se eliminará permanentemente el cupón "${codigo}".`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#64748b',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/cuponDelete.php?idCodigo=${idCodigo}`, {
                        method: 'DELETE'
                    });
                    const data = await res.json();
                    if (data.mensaje) {
                        Swal.fire('¡Eliminado!', data.mensaje, 'success');
                        cargarCupones();
                    } else {
                        // Fallback a codigosDelete.php
                        const res2 = await fetch(`${baseURL}/codigosDelete.php?idCodigo=${idCodigo}`, { method: 'DELETE' });
                        const d2 = await res2.json();
                        Swal.fire('¡Eliminado!', d2.mensaje || 'Cupón eliminado', 'success');
                        cargarCupones();
                    }
                } catch (e) {
                    toast.error('Error de red al eliminar cupón');
                }
            }
        });
    };

    const cuponesFiltrados = cupones.filter(c => {
        return (c.codigo || '').toLowerCase().includes(busqueda.toLowerCase());
    });

    return (
        <div className="cuponesContainer">
            <ToastContainer />

            {/* Cabecera */}
            <div className="cuponesHeader">
                <div className="cuponesTitleCol">
                    <h2><FontAwesomeIcon icon={faTicketAlt} /> Cupones de Descuento</h2>
                    <p>Crea y administra los códigos promocionales para aplicar descuentos en compras y pedidos.</p>
                </div>

                <div className="cuponesHeaderActions">
                    <button className="btnReloadCupones" onClick={cargarCupones} title="Recargar">
                        <FontAwesomeIcon icon={faSync} className={loading ? 'fa-spin' : ''} />
                    </button>
                    <NewCupon onCuponCreado={cargarCupones} />
                </div>
            </div>

            {/* Buscador */}
            <div className="cuponesToolbar">
                <div className="cuponesSearch">
                    <FontAwesomeIcon icon={faSearch} />
                    <input
                        type="text"
                        placeholder="Buscar cupón por código..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </div>
                <span className="cuponesCountBadge">
                    {cuponesFiltrados.length} {cuponesFiltrados.length === 1 ? 'cupón activo' : 'cupones'}
                </span>
            </div>

            {/* Tabla de Cupones */}
            <div className="cuponesTableCard">
                {loading ? (
                    <div className="cuponesLoading">Cargando cupones de descuento...</div>
                ) : cuponesFiltrados.length === 0 ? (
                    <div className="noCupones">No se encontraron cupones registrados.</div>
                ) : (
                    <table className="cuponesTable">
                        <thead>
                            <tr>
                                <th># ID</th>
                                <th>Código Promocional</th>
                                <th>Descuento</th>
                                <th>Vigencia</th>
                                <th>Estado</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cuponesFiltrados.map(c => {
                                const activo = (c.estado || 'activo').toLowerCase() === 'activo';
                                return (
                                    <tr key={c.idCodigo}>
                                        <td><strong>#{c.idCodigo}</strong></td>
                                        <td>
                                            <span className="cuponCodePill">{c.codigo}</span>
                                        </td>
                                        <td className="colDescuento">
                                            <strong>{moneda} {parseFloat(c.descuento || 0).toFixed(2)}</strong>
                                        </td>
                                        <td>
                                            <span className="cuponVigencia">
                                                <FontAwesomeIcon icon={faCalendarAlt} /> {c.vigencia || 'Sin límite'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={`cuponEstadoBadge ${activo ? 'estado-activo' : 'estado-inactivo'}`}>
                                                <FontAwesomeIcon icon={activo ? faCheckCircle : faTimesCircle} /> {c.estado || 'Activo'}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button
                                                className="btnDeleteCupon"
                                                onClick={() => eliminarCupon(c.idCodigo, c.codigo)}
                                                title="Eliminar cupón"
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
